import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _DarhboardLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("rect", { width: 6, height: 6, x: 4, y: 4, stroke: "currentColor", strokeLinejoin: "round", rx: 1 }), _jsx("rect", { width: 6, height: 6, x: 4, y: 14, stroke: "currentColor", strokeLinejoin: "round", rx: 1 }), _jsx("rect", { width: 6, height: 6, x: 14, y: 14, stroke: "currentColor", strokeLinejoin: "round", rx: 1 }), _jsx("rect", { width: 6, height: 6, x: 14, y: 4, stroke: "currentColor", strokeLinejoin: "round", rx: 1 })] }) });
}
const DarhboardLight = forwardRef(_DarhboardLight);
export { DarhboardLight };
